'use client';

import type { FC, PropsWithChildren } from 'react';
import { ReactQueryClientProvider } from './react-query-client-provider';

export const ClientProviders: FC<PropsWithChildren> = ({ children }) => {
  return <ReactQueryClientProvider>{children}</ReactQueryClientProvider>;
};
